export default __webpack_public_path__ + "static/media/Flag_of_Luxembourg.07a6c829.svg";